var map = {
	"./100013.png": 86,
	"./100013.webp": 1308,
	"./10005.png": 3469,
	"./10005.webp": 8835,
	"./11.png": 9931,
	"./11.webp": 7391,
	"./25.png": 7054,
	"./25.webp": 520,
	"./Our_Training_Programs_5.png": 3036,
	"./Our_Training_Programs_5.webp": 5680,
	"./Pros And Cons of AI In Manufacturing.jpg": 5645,
	"./Pros And Cons of AI In Manufacturing.webp": 9625,
	"./Seminar 2.png": 3518,
	"./Seminar 2.webp": 2434,
	"./adv_plc_c4.jpg": 5728,
	"./adv_plc_c4.webp": 9454,
	"./automationc-1.jpg": 7831,
	"./automationc-1.webp": 3877,
	"./blog banner1.jpg": 9890,
	"./blog banner1.webp": 916,
	"./blog3.jpg": 6030,
	"./blog3.webp": 3410,
	"./c7.jpg": 407,
	"./c7.webp": 7727,
	"./c8.jpg": 9044,
	"./c8.webp": 7674,
	"./c9.jpg": 7089,
	"./c9.webp": 1845,
	"./digital marketing.jpg": 1749,
	"./digital marketing.webp": 4907,
	"./how to begin 2.jpg": 4329,
	"./how to begin 2.webp": 4245,
	"./industrialautomation.png": 713,
	"./industrialautomation.webp": 4921,
	"./prog_c-2.jpg": 6102,
	"./prog_c-2.webp": 7300,
	"./reg_banner.jpg": 7570,
	"./reg_banner.webp": 292,
	"./robo_integ_c6.jpg": 4947,
	"./robo_integ_c6.webp": 6521,
	"./rock.png": 530,
	"./rock.webp": 9460,
	"./sca_da_data_acq_c5.jpg": 3960,
	"./sca_da_data_acq_c5.webp": 2770,
	"./schneider.png": 7350,
	"./schneider.webp": 6538
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 649;